export default "__VITE_ASSET__DE2W9ZT7__"